import { render, staticRenderFns } from "./TeamUsers.vue?vue&type=template&id=0bde4862&scoped=true"
import script from "./TeamUsers.vue?vue&type=script&lang=js"
export * from "./TeamUsers.vue?vue&type=script&lang=js"
import style0 from "./TeamUsers.vue?vue&type=style&index=0&id=0bde4862&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.3.4_css-loader@6.8.1_webpack@5.88.2__lodash@4.17_2b05b4b7daaef4c710e484e85375d138/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bde4862",
  null
  
)

export default component.exports